module.exports = __webpack_public_path__ + "img/game03.95bbe2da.png";